// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Fab,
    Typography,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { getDoctag } from '../../../../api/helper';

export default function Index() {
    const navigate = useNavigate();

    // ** State
    const [nik, setNik] = useState("");
    const [wo, setWo] = useState("");
    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        // Ambil dari localStorage
        const storedNik = localStorage.getItem("NIK") || "-";
        const storedWo = localStorage.getItem("WO") || "-";

        setNik(storedNik);
        setWo(storedWo);
    }, []);

    const handleDelete = (row: any) => {
        // Swal.fire({
        //     title: 'Konfirmasi',
        //     text: 'Apakah anda ingin hapus data ini ?',
        //     icon: 'question',
        //     showCancelButton: true,
        //     confirmButtonColor: '#337ab7',
        //     cancelButtonColor: '#ffc107',
        //     confirmButtonText: 'Hapus'
        // }).then(result => {
        //     if (result.isConfirmed) {
        //         Swal.fire({
        //             title: 'Now loading',
        //             allowEscapeKey: false,
        //             allowOutsideClick: false,
        //             didOpen: () => {
        //                 Swal.showLoading()
        //             }
        //         })

        //         const url = apiUrl.apiUrl + '/sales/sales-order/delete/' + row.id
        //         axios
        //             .delete(url, {
        //                 headers: {
        //                     Authorization: `Bearer ${token}`,
        //                 },
        //             })
        //             .then(response => {
        //                 if (response.data.success) {
        //                     Swal.fire({
        //                         title: 'Pemberitahuan',
        //                         text: response.data.message,
        //                         icon: 'success',
        //                         timer: 1000,
        //                         timerProgressBar: true,
        //                         willClose: () => {
        //                             getData(tabs)
        //                         }
        //                     })
        //                 } else {
        //                     Swal.fire({
        //                         title: 'Pemberitahuan',
        //                         text: response.data.message,
        //                         icon: 'error'
        //                     })
        //                 }
        //             })
        //             .catch(error => {
        //                 Swal.fire({
        //                     title: 'Pemberitahuan',
        //                     text: error.message,
        //                     icon: 'error'
        //                 })
        //             })
        //     }
        // })
    };

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/sales-order/detail/' + id)}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={1} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12} sm={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                    <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="h6">NIK : {nik}</Typography>
                        <Typography variant="h6">WO : {wo}</Typography>
                        <Typography variant="h6"></Typography>
                    </CardContent>
                </div>
                <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                    <CardContent sx={{ display: "flex", justifyContent: "flex-start" }}>
                        <MsiDatagrid array={listData} actions={actionData} />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}
